import {Button} from '@priority-software/priority-style-react';
import React, {useContext} from 'react';

import styles from './styles.module.scss';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';
import {getValueByColName} from '../../../_shared/GWTBridge/invoke/formTable';
import {AppSearchesContext} from '../AppSearchesContext';
import {APPFORMS_NAME, COL_NAME_PARENT, COL_NAME_TYPE} from '../consts';
import {isModuleExists} from '../../License/store';
import {PREMUIM_APP_GEN_LICENSE} from '../../License/consts';
import {Tooltip} from '../../../components/Common/Tooltip/index';

const AppSearchesButton = () => {
    const {handleOpen} = useContext(AppSearchesContext);
    const {currentForm} = formsStore;

    let isParent,
        isTypeForm = false;

    if (currentForm?.name === APPFORMS_NAME) {
        isParent = !getValueByColName(COL_NAME_PARENT);
        isTypeForm = getValueByColName(COL_NAME_TYPE) === 'F';
    }
    const isEnabled = isTypeForm && isParent;
    const tooltip = !isTypeForm
        ? getLocalizedText(texts.NotFormTypeTooltip)
        : !isParent
        ? getLocalizedText(texts.IsSubFormTooltip)
        : getLocalizedText(texts.AddSearchBtnTooltip);

    const isAppGenModuleExists = isModuleExists(PREMUIM_APP_GEN_LICENSE);

    return (
        currentForm?.name === 'APPFORMS' &&
        isAppGenModuleExists && (
            <Tooltip tooltip={tooltip}>
                <Button
                    componentClasses={styles.appSeachButton}
                    disabled={!isEnabled}
                    skin="secondary"
                    onClick={handleOpen}
                >
                    {getLocalizedText(texts.AppSearchTitle)}
                </Button>
            </Tooltip>
        )
    );
};

export default AppSearchesButton;
